import { render, staticRenderFns } from "./HeadersModal.vue?vue&type=template&id=08955657&"
import script from "./HeadersModal.vue?vue&type=script&lang=js&"
export * from "./HeadersModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports